(function () {
  var outer = document.querySelector('.halo-scale-outer');
  var root = document.querySelector('.halo-scale-root');
  if (!outer || !root) return;

  function updateHaloScale() {
    var w = window.innerWidth;
    if (w < 1729) {
      root.style.transform = '';
      outer.style.height = '';
      return;
    }
    var scale = w / 1728;
    root.style.transform = 'scale(' + scale + ')';
    outer.style.height = (root.offsetHeight * scale) + 'px';
  }

  updateHaloScale();
  window.addEventListener('resize', updateHaloScale);
  window.addEventListener('load', updateHaloScale);
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(updateHaloScale).observe(root);
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHaloScale);
  }
})();
